export const LS_KEYS = {
  AWARD_SHOWN: 'lorgar-award-shown',
};

export const getLocalStorageItem = (key) => localStorage.getItem(key);
export const setLocalStorageItem = (key, value) =>
  localStorage.setItem(key, value);

export const saveLorgarAwardShown = () =>
  localStorage.setItem(LS_KEYS.AWARD_SHOWN, Date.now().toString());
export const getLorgarAwardShown = () =>
  localStorage.getItem(LS_KEYS.AWARD_SHOWN);
